import axios from 'axios';
import { ProjectShowroomInfo } from '../models/investors';

const loadAbort = () => {
  return new AbortController();
};

export const updateShowroomInfoEndpoint = (
  projectId: string,
  payload: Omit<ProjectShowroomInfo, 'image'>,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'PUT',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/showroom-info`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
